module.exports = __webpack_public_path__ + "static/media/search-synonyms.7e6d4fc7.png";